import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

/**
 * Directive die die Höhe des Host-Elements als CSS Custom Property `--navbar-height` trackt.
 * Nutzt ResizeObserver für automatische Updates bei Größenänderungen.
 *
 * Verwendung: `<nav wdNavbarHeight>...</nav>`
 */
@Directive({
	selector: '[wdNavbarHeight]',
	standalone: true
})
export class WdNavbarHeightDirective implements AfterViewInit, OnDestroy {
	private ro?: ResizeObserver;

	constructor(private el: ElementRef<HTMLElement>) {}

	ngAfterViewInit() {
		const update = () => {
			document.documentElement.style.setProperty(
				'--navbar-height',
				`${this.el.nativeElement.offsetHeight}px`
			);
		};
		update();
		this.ro = new ResizeObserver(() => update());
		this.ro.observe(this.el.nativeElement);
	}

	ngOnDestroy() {
		this.ro?.disconnect();
	}
}
